import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { getCoupons, getUserCart, clearCart, checkout } from "../../api/utils";
import { useGlobalContext } from "../../context/globalContext";
import { Toast } from 'bootstrap'; 

const Checkout = () => {
    const navigate = useNavigate();
    const toastRef = useRef(null);
    const [purchaseItems, setPurchaseItems] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [couponList, setCouponList] = useState([]);
    const {setActiveMenu, setErrorMessage, setShowErrorMessage, handleCartAdd} = useGlobalContext();
    const [formData, setFormData] = useState({
        fname: '',
        lname: '',
        parentsName: '',
        parentEmail: '',
        address: '',
        university: '',
        city: '',
        country: '',
        zipcode: '',
        email: '',
        phone: ''
      });
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
      };

    useEffect(() => {
        const fetchData = async () => {
          try {
            const [userCartData, couponData] = await Promise.all([
              getUserCart(),
              getCoupons('checkout')
            ]);
      
            if (userCartData.status && couponData.status) {
                setPurchaseItems(userCartData.data);
                setCouponList(couponData.data);
                setLoadingData(false);
            } else {
              console.log("Error: One or both fetch requests failed.");
            }
          } catch (error) {
            console.log("Error fetching data:", error);
          }
        };
      
        fetchData();
      }, []);

    
    const handleClearCart = async () => {
        const response = await clearCart();

        if(response.status) {
            setErrorMessage('Cart Deleted');
            setShowErrorMessage(true);
            handleCartAdd([]);
            navigate("/");
        }
    }
    
    const handleCheckout = async () => {
        const { fname, lname, parentsName, parentEmail, address, university, city, country, zipcode, email, phone } = formData;
    
        if ( !fname || !lname || !parentsName || !parentEmail || !address || !university || !city || !country || !zipcode || !email || !phone) {
          alert('Please fill in all fields before submitting.');
          return;
        }

        const response = await checkout(formData);
        if (response.status === true && toastRef.current) {
            const toast = new Toast(toastRef.current);
            toast.show();
          }
        
    };

    setActiveMenu("#");

    return(
        loadingData == true ? (
            <div class="d-flex justify-content-center">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
                {
                    purchaseItems === null || purchaseItems.length === 0 ? 
                    <div>
                        <div className="d-flex justify-content-center align-items-center vh-100">
                            <div className="text-center">
                                <img
                                    src="/images/empty-cart.png"
                                    alt="Empty Cart"
                                    className="mb-4"
                                    style={{ maxWidth: '200px' }}
                                />
                                <h4 className="fw-bold">Your cart is empty</h4>
                                <p className="text-muted">
                                    Looks like you have not added anything to your cart. <br />
                                    Go ahead &amp; explore top categories.
                                </p>
                                <a href="/all-courses" className="btn btn-primary primary-button mt-3">
                                    Go to Courses
                                </a>
                            </div>
                        </div>
                    </div>:
                    <div className="container mt-5 h44">
                        <div className="row">
                            <div className="col-md-7">
                            <h5 className="mb-3">Contact information</h5>
                                <form onSubmit={(e) => { e.preventDefault();  handleCheckout();}}>
                                    <div className="mb-3">
                                        <input type="email" name="email" className="form-control" placeholder="Email" value={formData.email} onChange={handleChange}/>
                                    </div>
                                    <div className="mb-3">
                                        <input type="number" name="phone" className="form-control" placeholder="Phone number" value={formData.phone} onChange={handleChange}/>
                                    </div>
                                    <div className="mb-4 form-check">
                                        <input className="form-check-input" type="checkbox" id="offersCheck"/>
                                        <label className="form-check-label" for="offersCheck">
                                            The Email/Phone number will be used for all the communications.
                                        </label>
                                    </div>
                                    {/* <h5 className="mb-3">Shipping address</h5> */}
                                    <div className="row">
                                        <div className="col">
                                            <input type="text" name="fname" className="form-control" placeholder="First name" value={formData.fname} onChange={handleChange}/>
                                        </div>
                                        <div className="col">
                                            <input type="text" name="lname" className="form-control" placeholder="Last name" value={formData.lname} onChange={handleChange}/>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <input type="text" name="parentsName" className="form-control" placeholder="Father / Mother name" value={formData.parentsName} onChange={handleChange}/>
                                    </div>
                                    <div className="mb-3">
                                        <input type="email" name="parentEmail" className="form-control" placeholder="Parents Email" value={formData.parentEmail} onChange={handleChange}/>
                                    </div>
                                    <div className="mb-3">
                                        <input type="text" name="address" className="form-control" placeholder="Address" value={formData.address} onChange={handleChange}/>
                                    </div>
                                    <div className="mb-3">
                                        <input type="text" name="university" className="form-control" placeholder="School / College / University" value={formData.university} onChange={handleChange}/>
                                    </div>
                                    <div className="row mb-3">
                                    <div className="col">
                                        <input type="text" name="city" className="form-control" placeholder="City" value={formData.city} onChange={handleChange}/>
                                    </div>
                                    <div className="col">
                                        <select className="form-select" name="country" value={formData.country} onChange={handleChange}>
                                            <option selected>Country/Region</option>
                                            <option value="1">Saudi Arabia</option>
                                            <option value="1">India</option>
                                        </select>
                                    </div>
                                    {/* <div className="col">
                                        <select className="form-select">
                                        <option selected>State</option>
                                        <option value="1">Riyadh</option>
                                        </select>
                                    </div> */}
                                    <div className="col">
                                        <input type="number" className="form-control" name="zipcode" placeholder="ZIP code" value={formData.zipcode} onChange={handleChange}/>
                                    </div>
                                    </div>

                                    <button className="btn btn-dark w-100 primary-button">Pay Now</button>
                                    <div className="text-center mt-2">
                                        <a href="#" className="text-decoration-none text-primary" onClick={() => {handleClearCart()}}>Clear Cart</a>
                                    </div>
                                </form>
                            </div>

                            <div className="col-md-5">
                                <div className="card p-3">
                                    {
                                        purchaseItems?.courses.map((course, index) => (
                                            <div className="d-flex align-items-center mb-3" key={index}>
                                                <img src="images/courseImg.png" alt="Product" className="me-3" width={50} height={50}/>
                                            <div>
                                                <h6 className="mb-0">{course.name}</h6>
                                            </div>
                                            <div className="ms-auto fw-bold">${course.price}</div>
                                            </div>
                                        ))
                                    }
                                    <div className="mb-3">
                                    <input type="text" className="form-control" placeholder="Discount Code"/>
                                    <button className="btn btn-secondary w-100 mt-2">Apply</button>
                                    </div>

                                    <div className="d-flex justify-content-between">
                                    <span>Subtotal</span>
                                    <span>${purchaseItems.amount}</span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                    <span>Tax</span>
                                    <span className="text-muted">{purchaseItems.tax}%</span>
                                    </div>
                                    <hr/>
                                    <div className="d-flex justify-content-between fw-bold fs-5">
                                    <span>Total</span>
                                    <span>${purchaseItems.final_amt}</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 11 }}>
                            <div
                                ref={toastRef}
                                className="toast align-items-center text-bg-primary border-0"
                                role="alert"
                                aria-live="assertive"
                                aria-atomic="true">
                                <div className="d-flex">
                                <div className="toast-body">
                                    Payment successful!
                                </div>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white me-2 m-auto"
                                    data-bs-dismiss="toast"
                                    aria-label="Close"
                                ></button>
                                </div>
                            </div>
                        </div>
                    </div>
                }    
            </>
          )
    )
}

export default Checkout